import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { DefaultTheme } from "@material-ui/styles";
import { createTheme } from "@material-ui/core";
import { MemoryRouter } from "react-router-dom";
import { EntityDTO } from "./DTO/Entity";

export type MicroFrontendContract = {
  containerId: string;
  theme: DefaultTheme;
  token: string;
  parameters: {
    descriptor?: EntityDTO;
    outputport?: any;
  };
};

declare global {
  interface Window {
    renderIndustrialEquipmentCatalog: (params: MicroFrontendContract) => void;
    unmountIndustrialEquipmentCatalog: (containerId: string) => void;
  }
}

window.renderIndustrialEquipmentCatalog = (params) => {
  console.log(params, `EQHub Industrial Equipment Catalog initializing...`);
  ReactDOM.render(
    <React.StrictMode>
      <MemoryRouter>
        <App
          theme={createTheme({})}
          descriptor={params.parameters?.descriptor}
          outputport={params.parameters?.outputport}
        />
      </MemoryRouter>
    </React.StrictMode>,
    document.getElementById(params.containerId)
  );
};

window.unmountIndustrialEquipmentCatalog = (containerId) => {
  const el = document.getElementById(containerId);
  if (!el) {
    return;
  }

  ReactDOM.unmountComponentAtNode(el);
};

// Development mode: auto-render if not in Witboost
// if (process.env.NODE_ENV === 'development') {
//   const rootElement = document.getElementById('root');
//   if (rootElement && !rootElement.hasChildNodes()) {
//     // Test outputport from YAML file
//     const testOutputPort = {
//       id: 'urn:dmb:cmp:rdl:202410311657D20FPQAKSOPXB2001001MAINPRODUCTIONMANIFOLD:0:RDS431594',
//       kind: 'RDLData',
//       name: 'BLOCK AND BLEED VALVE',
//       version: '0.0.0',
//       domain: 'rdl',
//       RDLClass: 'RDS431594'
//     };

//     console.log('🧪 Development mode - Testing with outputport:', testOutputPort);

//     ReactDOM.render(
//       <React.StrictMode>
//         <MemoryRouter>
//           <App
//             theme={createTheme({})}
//             outputport={testOutputPort}
//           />
//         </MemoryRouter>
//       </React.StrictMode>,
//       rootElement
//     );
//   }
// }
